import { plainToInstance } from 'class-transformer'

import { Entity } from '@core/entities/entity'
import { IBriefingSessionAuditMetadata } from './IBriefingSessionAuditMetadata'

export class BriefingSessionAuditMetadata extends Entity<IBriefingSessionAuditMetadata> {
  briefedSessionRoles: Array<{
    briefingText: string
    participants: Array<{
      external: boolean
      firstName: string
      lastName: string
      company: string
      phone: string
      userId: number
      signatureUrl: string
    }>
    roleId: number
    roleName: string
  }>

  briefingPeriod: {
    startedOn: string
    endedOn: string
  }

  public static new(payload: unknown): BriefingSessionAuditMetadata {
    const entity = plainToInstance(BriefingSessionAuditMetadata, payload)
    return entity
  }
}
